<template>
	<div class="content">	    
		<el-row type="flex" justify="space-between" align="middle" style="height: 50px;">
			<el-col :span="12">
				<div v-if="showstore.state.isLogin">
					<el-dropdown>
					  <span class="el-dropdown-link">
					  {{showstore.state.userInfo.name?showstore.state.userInfo.name:''}}<i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <el-dropdown-item  @click.native="handleCenter">用户中心</el-dropdown-item>
					    <el-dropdown-item  @click.native="handOut">安全退出</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
				<div v-else>
					<el-button type="primary" size="medium" @click="toWxAuthorization()">登录</el-button>
					<!-- <el-button type="warning" size="medium" @click="goRegister()">注册</el-button> -->
				</div>
			</el-col>
			<el-col :span="12" style="text-align: right;">
				<!-- <el-link style="font-weight: bold;" :underline="false" :href=" $imgBaseUrl+'/sovo/aboutUs'" target="_blank">关于超市</el-link> -->
			</el-col>
		</el-row>
	</div>
</template>
<script>
import { loginout ,wxAuthorization} from '@/api';
import store from '@/store/index.js';
export default {
  name: 's-header-top', 
  data () {
	return {
	  token: '',
	  redirect_uri:'https://xyqyfw.com/sovo',
	  showstore:store
	}
  },  
  mounted() {
	let _this = this;
	this.redirect_uri = window.location.href;
	this.token = localStorage.getItem('token');
	window.addEventListener('beforeunload', () => {	
		localStorage.setItem('store', JSON.stringify(store.state))		
	});
	if (this.getQueryString('code') && !store.state.isLogin) {
		console.log('=code=',this.getQueryString('code') );
		console.log('=islogin=',store.state.isLogin );
		wxAuthorization({ code: this.getQueryString('code') }).then(res => {
				if (res.code == 0) {
					console.log('=wcallback=',res.data);
					_this.token = res.data.token;
					localStorage.setItem('token', res.data.token);
					store.commit('changeIsLogin', true);
					store.commit('changeUserInfo', res.data.user);
					localStorage.setItem('store', JSON.stringify(store.state));
					
				} else {
					this.$alert(res.msg);
					localStorage.clear();
				}
			});
	}
  },
  methods:{
	  //获取登录成功后地址后参数
	  getQueryString(name) {
	  	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	  	var r = window.location.search.substr(1).match(reg);
	  	if (r != null) {
	  		return unescape(r[2]);
	  	}
	  	return null;
	  },
	  toWxAuthorization(){		
	  	window.location.href ="https://open.weixin.qq.com/connect/qrconnect?appid=wx8683c33354eeddb1&redirect_uri="+this.redirect_uri+"&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect"
	  },
	  goLogin(){
		  let routeUrl = this.$router.resolve({
		  	path: '/login' //跳转的路径
		  });
		  window.open(routeUrl.href, '_blank');
	  },
	  goRegister(){
		let routeUrl = this.$router.resolve({
			path: '/register' //跳转的路径
		});
		window.open(routeUrl.href, '_blank');
	  },
	  handleCenter(){
		  let routeUrl = this.$router.resolve({
		  	path: '/userCenter' //跳转的路径
		  });
		  window.open(routeUrl.href, '_blank');
	  },
	  //退出登录
	  handOut(){		
		this.token = '';
		loginout().then(res=> {
			this.$router.push({path:'/index'})
			store.commit('changeIsLogin', false);
			store.commit('changeUserInfo',null);
			localStorage.clear()
			sessionStorage.clear()
		})
	  }
  }
}
	
</script>




// WEBPACK FOOTER //
// src/components/header_top.vue